import { Component, OnInit } from '@angular/core';

import { tutorials } from './tutorials';
import { Tutorial }  from './tutorial.model';
import { AuthUser } from '@shared/models/user/auth-user';
import { filter, map, Observable, take } from 'rxjs';
import { UserService } from '@services/user.service';


@Component({
  selector:    'red-tutorials',
  templateUrl: './tutorials.component.html',
  styleUrls:   [ './tutorials.component.scss' ]
})
export class TutorialsComponent {
  
  public activeUser$: Observable<AuthUser>;
  public tutorials: Tutorial[];

  public isHidden: boolean;

  constructor(
    private userService: UserService,
  ) {
    this.tutorials = tutorials.sort((a: Tutorial, _b: Tutorial) => {
      return a.video ? -1 : 1;
    });

    this.userService.getActiveUser().pipe(
     filter(user => !!(user && user.parceiroId)),
     map(user => user.parceiroId)
   ).subscribe(partnerId => {
     if(partnerId === 18 || partnerId === 25){
       this.isHidden = true;
     }
   });
  }
}
